export const GWEI_PER_TOKEN = 1e9
export const WEI_PER_TOKEN = 1e18
